
export default function BenefitsSection() {
  const benefits = [
    {
      category: '利益の源泉',
      items: ['停止時間↓', '人件費↓', '不良・再加工↓'],
      icon: 'ri-money-dollar-circle-line',
      color: 'yellow'
    },
    {
      category: '受注競争力',
      items: ['監査に強い"証拠"', '値下げに頼らず受注', '客観データで即回答'],
      icon: 'ri-trophy-line',
      color: 'yellow'
    },
    {
      category: '夜間の安心',
      items: ['異常は安全停止', '品質保全', '翌朝の即再開を前提設計'],
      icon: 'ri-shield-check-line',
      color: 'yellow'
    },
    {
      category: '将来拡張',
      items: ['venturion/TMS接続', '測定→交換→エビデンス', '一筆書きで完結'],
      icon: 'ri-rocket-line',
      color: 'yellow'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            【導入で得られる"具体的なベネフィット"】
          </h2>
          <p className="text-xl text-gray-600">
            単なる自動化を超えた、経営改善効果
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-yellow-200">
              <div className="w-16 h-16 bg-yellow-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className={`${benefit.icon} text-3xl text-yellow-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 text-center mb-4">
                {benefit.category}
              </h3>
              
              <ul className="space-y-2">
                {benefit.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-center text-gray-700">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3 flex-shrink-0"></div>
                    <span className="text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900">
              実際の改善効果例
            </h3>
            
            <div className="space-y-4">
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h4 className="font-semibold text-yellow-800 mb-2">時間効率改善</h4>
                <p className="text-yellow-700 text-sm">
                  交換時間：40分/本 x 8＝320分 → 5分（カッターをパレットにセットするのみ）<br />
                  段取り回数：1日5回 → 年間1,250回の時短効果
                </p>
              </div>
              
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-800 mb-2">品質安定化</h4>
                <p className="text-gray-700 text-sm">
                  締付けトルクの再現性：±5% → ±1%<br />
                  不良率：大幅改善、監査対応時間90%削減
                </p>
              </div>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h4 className="font-semibold text-yellow-800 mb-2">人材効率化</h4>
                <p className="text-yellow-700 text-sm">
                  新人教育期間：3ヶ月 → 1週間<br />
                  技能者依存度：90% → 10%
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="max-w-md w-full">
              <div className="relative rounded-lg shadow-lg overflow-hidden">
                <iframe
                  width="100%"
                  height="300"
                  src="https://www.youtube.com/embed/w-EtCPTc0v0"
                  title="micBoxチップ・スクリュ廃棄～スクリュ取り出し～焼付防止剤注油"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full"
                ></iframe>
              </div>
              <p className="text-center text-gray-700 font-semibold mt-4">
                チップ・スクリュ廃棄～スクリュ取り出し～焼付防止剤注油・・・<br />
                <span className="text-sm text-red-600">（音量注意‼ 音声は動画の内容に関連しません）</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
